import React, { Component } from "react";
import { connect } from "react-redux";

import { setBetPlaced, setCashedOut } from "../store/auth/actions";
import { setGameState } from "../store/game/actions";
import constants from "../store/constants";
import RunGameAPI from "../api/run_game";
import SignInAPI from "../api/sign_in";
import PoolAPI from "../api/pool";
import BetAPI from "../api/bet";
import cable from "../api/cable";
import Counter from "./Counter";
// import Graph from "./Graph";

class Game extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 10,
      betAmount: "1",
      showCountdown: false,
      showMultiplier: false,
      bets: [],
      // graphData: [],
      multiplierHistory: [],
      timer: 0,
      finalTime: 0,
      finalMultiplier: 0,
      cashOut: true,
      bang: false,
      showWaitButton: false,
      poolAmount: 0,
    };
  }

  // dataAppend = () => {
  //   this.setState({
  //     graphData: [
  //       ...this.state.graphData,
  //       {
  //         x: this.state.timer.toFixed(2),
  //         y: (this.state.timer / 10 + 1).toFixed(2),
  //       },
  //     ],
  //   });
  // };

  // setCounter = () => {
  //   // (this.state.counter > 0.1) ? this.setState({ counter: this.state.counter - 0.1 }) : this.setState({counter: 0});
  //   let d = new Date();
  //   let countDownDate = d.getSeconds() + 10;
  //   let timer = setInterval(() => {
  //     let seconds = new Date().getTime();
  //     let difference = countDownDate - seconds;
  //     let results = Math.floor((difference % (1000 * 60)) / 1000);
  //     this.setState({counter: results})

  //     if (difference < 0) {
  //       clearInterval(timer);
  //     }
  //   }, 1000);
  // }

  // onCountdownStart = () => {
  //   this.setCounter();
  //   this.r = setTimeout(() => {
  //      this.onCountdownStart();
  //   }, 100);
  // }

  // onCountdownStop = () => {
  //   clearTimeout(this.r);
  // };

  onStart = () => {
    this.setState({ timer: this.state.timer + 0.01 });
    // this.dataAppend();
  };

  timer = () => {
    this.onStart();
    this.f = setTimeout(() => {
      this.timer();
    }, 10);
  };

  onStop = () => {
    clearTimeout(this.f);
  };

  onReset = () => {
    this.setState({ timer: 0 });
  };

  // clear = () => {
  //   this.setState({graphData: []})
  // };

  handleCountDownStart = () => {
    PoolAPI.getPoolAmount()
      .then((response) => {
        console.log("POOLAMOUNT");
        console.log(response.data.pool_value);
        this.setState({ poolAmount: response.data.pool_value });
      })
      .catch((error) => {
        console.log(error);
      });
    // setInterval(() => {
    //   this.clear();
    // }, 2000);
    // this.onCountdownStart();
    // this.setCounter();
    this.props.setGameState(constants.SET_COUNTDOWN_STARTED);
    this.props.setBetPlaced({ betPlaced: false });
    this.props.setCashedOut({ cashedOut: false });
    this.onReset();
    this.setState({ showMultiplier: false });
    this.setState({ showCountdown: true });

    this.setState({ bets: [] });
  };

  handleCountDownStop = () => {
    // this.onCountdownStop();
    this.props.setGameState(constants.SET_COUNTDOWN_STOPPED);
    this.setState({ showCountdown: false });
    this.setState({ bang: false });
  };

  handleMultiplierStart = () => {
    this.setState({ cashOut: true });

    if (this.props.betPlaced) {
      this.setState({ showWaitButton: false });
    } else {
      this.setState({ showWaitButton: true });
    }

    this.props.setGameState(constants.SET_MULTIPLIER_STARTED);
    this.setState({ showMultiplier: true });
    this.timer();
  };

  handleMultiplierStop = () => {
    this.props.setGameState(constants.SET_MULTIPLIER_STOPPED);
    this.props.setBetPlaced({ betPlaced: false });
    this.setState({ bang: true });
    // console.log("FINAL MULTIPLIER: ",this.state.finalMultiplier)
    // let time = 10 * (this.state.finalMultiplier - 1);
    // console.log(" handleMultiplierStop TIME TO RUN THR GAME: ",time)
    // console.log(" handleMultiplierStop FINAL MULTIPLIER: ",this.state.finalMultiplier)
    this.onStop();
    PoolAPI.getPoolAmount()
      .then((response) => {
        console.log("POOLAMOUNT");
        console.log(response.data.pool_value);
        this.setState({ poolAmount: response.data.pool_value });
      })
      .catch((error) => {
        console.log(error);
      });
    RunGameAPI.get_multiplier()
      .then((response) => {
        this.setState({ multiplierHistory: response.data.multiplier });
      })
      .catch((error) => {
        console.log(error);
      });
    this.setState({ counter: 10 });
  };

  handleStartGame = () => {
    console.log("Going to start game!");
    RunGameAPI.run_script();
  };

  handleCreateBet = () => {
    this.props.setBetPlaced({ betPlaced: true });
    this.setState({ showWaitButton: true });
    BetAPI.createBet({
      bet: {
        user_id: this.props.currentUser.user_id,

        amount: parseFloat(this.state.betAmount),
      },
    })

      .then()
      .catch((error) => {
        console.log("error", error);
      });
  };

  handleCashOut = () => {
    this.setState({ cashOut: false });
    this.setState({ showWaitButton: true });
    this.props.setCashedOut({ cashedOut: true });
    BetAPI.updatebet({
      bet: {
        user_id: this.props.currentUser.user_id,
        cash_out: (this.state.timer / 10 + 1).toFixed(2),
      },
    });
  };

  handleSignOut = () => {
    SignInAPI.logout()
      .then((response) => {
        console.log(response.data);
        localStorage.clear();
        window.location.href = "https://crash-2f0ef.web.app/";
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    cable.subscriptions.create(
      {
        channel: "GameStatusChannel",
      },
      {
        connected: () => console.log("connected"),
        disconnected: () => console.log("disconnected"),
        received: (data) => {
          if (data.game_status === "countdown_start") {
            this.handleCountDownStart();
          } else if (data.game_status === "countdown_stop") {
            this.handleCountDownStop();
          } else if (data.game_status === "checkout_start") {
            // this.handleMultiplierStart();
          } else if (data.game_status === "checkout_stop") {
            // console.log("HANDLE MULTIPLIR STOPPED CALLED")
            // this.handleMultiplierStop();
          } else if (
            data.game_status === "checkout_multiplier_value_from_server"
          ) {
            console.log("checkout_multiplier_value_from_server");
            this.setState({ finalMultiplier: data.multiplier });
            let time = 10 * (data.multiplier - 1);
            console.log("TIME:", time);
            this.handleMultiplierStart();
            setTimeout(() => {
              this.handleMultiplierStop();
            }, time * 1000);
          }
        },
      }
    );

    cable.subscriptions.create(
      {
        channel: "BetStatusChannel",
      },
      {
        connected: () => console.log("connected"),
        disconnected: () => console.log("disconnected"),
        received: (data) => {
          if (data.bet_status === "bet_created") {
            const { user_id, cash_out, amount, profit } = data;
            this.setState((prevState) => ({
              bets: [...prevState.bets, { user_id, cash_out, amount, profit }],
            }));
          } else if (data.bet_status === "bet_updated") {
            const { user_id, cash_out, amount, profit } = data;
            let tempBets = [...this.state.bets];
            let index = tempBets.findIndex((bet) => bet.user_id === user_id);
            tempBets[index] = { user_id, cash_out, amount, profit };
            this.setState({ bets: tempBets });
          }
        },
      }
    );
  }

  componentWillUnmount() {
    cable.disconnect();
  }

  render() {
    return (
      <div className="gameMainContainer">
        <div
          className="gameTextContainer"
          style={{
            textAlign: "center",
            marginTop: "40px",
            fontSize: "36px",
            color: "#5ddb1c",
          }}
        >
          Game
          <button
            className="betButton"
            style={{
              marginLeft: "10px",
            }}
            onClick={() => {
              this.handleSignOut();
            }}
          >
            Signout
          </button>
        </div>

        <p>Pool Amount: {this.state.poolAmount}</p>
        <p> Email: {this.props.currentUser.email}</p>

        <div className="graph-nd-betData-container relative">
          <div className="BetDataTableInner absolute">
            <div className="betDataTableHeading my_row">
              <div className="BetDatatHeading my_row_item_4 my_row justify">
                <span>User Id</span>
              </div>
              <div className="BetDatatHeading my_row_item_4 my_row justify">
                <span>Cashout</span>
              </div>
              <div className="BetDatatHeading my_row_item_4 my_row justify">
                <span>Ammount</span>
              </div>
              <div className="BetDatatHeading my_row_item_4 my_row justify">
                <span>Profit</span>
              </div>
            </div>

            <div className="betTableUserBetContaienr-main">
              {this.state.bets.map((bet, index) => (
                <div key={index} className="individualUser-bet my_row">
                  <div className="user-bet-id my_row_item_4 my_row justify">
                    <span>{bet.user_id}</span>
                  </div>
                  <div className="user-bet-cashout my_row_item_4 my_row justify">
                    <span>{bet.cash_out}</span>
                  </div>
                  <div className="user-bet-ammount my_row_item_4 my_row justify">
                    <span>{bet.amount}</span>
                  </div>
                  <div className="user-bet-profit my_row_item_4 my_row justify">
                    <span>{bet.profit}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="GraphMainContainer my_row justify relative">
            {/* Insert Graph Here */}
            {/* <Graph graphData={this.state.graphData} /> */}
            <div className="crashHistory-Conatainer absolute my_row justify">
              <div className="crashHistory-Container-inner">
                <div className="histtoryContainer-elems-container my_row justify">
                  {this.state.multiplierHistory.map((multiplier, index) => {
                    return (
                      <div
                        key={index}
                        className="history-data-item my_row justify"
                      >
                        <span>{multiplier} x</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="GraphInnerContainer my_row justify">
              {this.state.showCountdown && <Counter val={10} />}
              {this.state.showMultiplier && (
                <div className="multiplierMain">
                  <div>
                    {this.state.bang ? (
                      <p
                        style={{
                          fontSize: "30px",
                          color: "yellow",
                        }}
                      >
                        Bang @ {`${(this.state.timer / 10 + 1).toFixed(2)}x`}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: "30px",
                        }}
                      >{`${(this.state.timer / 10 + 1).toFixed(2)}x`}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <>
          <div className="betting-elems-container">
            <div className="betAmmount-field-container">
              <div
                className="betPlacerInput-label"
                style={{
                  textAlign: "center",
                  marginBottom: "20px",
                }}
              >
                <label>ENTER BET AMOUNT:</label>
              </div>
              <div className="my_row justify">
                <input
                  className="betAmmountField"
                  onFocus={() => {
                    this.setState({ betAmount: "1" });
                  }}
                  value={this.state.betAmount}
                  onChange={(e) => {
                    this.setState({
                      betAmount: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div
              className="BetCashout my_row justify"
              style={{
                widht: "200px",
                margin: "0 auto",
              }}
            ></div>

            <div className="bet-placing-buttonContainer my_row justify">
              {/* {this.props.game.gameState == constants.SET_COUNTDOWN_STARTED &&
                !this.props.betPlaced && (
                  <button
                    className="betButton"
                    onClick={() => {
                      this.handleCreateBet();
                    }}
                  >
                    CREATE BET
                  </button>
                )}

              {this.props.game.gameState == constants.SET_MULTIPLIER_STARTED &&
                this.props.betPlaced && (
                  <button
                    // disabled={!this.state.cashOut}
                    className="betButton"
                    onClick={() => {
                      this.handleCashOut();
                    }}
                  >
                    CASH OUT
                  </button>
                )} */}
              {this.props.game.gameState === constants.SET_COUNTDOWN_STARTED &&
              !this.props.betPlaced ? (
                <>
                  <button
                    className="betButton"
                    onClick={() => {
                      this.handleCreateBet();
                    }}
                  >
                    CREATE BET
                  </button>
                </>
              ) : (
                <>
                  {this.props.game.gameState ===
                    constants.SET_MULTIPLIER_STARTED &&
                  this.props.betPlaced &&
                  !this.props.cashedOut ? (
                    <>
                      <button
                        // disabled={!this.state.cashOut}
                        className="betButton"
                        onClick={() => {
                          this.handleCashOut();
                        }}
                      >
                        CASH OUT
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="wait">Wait</button>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </>
        <></>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
    betPlaced: state.auth.betPlaced,
    cashedOut: state.auth.cashedOut,
    game: state.game,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setGameState: (gameState) => dispatch(setGameState(gameState)),
    setBetPlaced: (betPlaced) => dispatch(setBetPlaced(betPlaced)),
    setCashedOut: (cashedOut) => dispatch(setCashedOut(cashedOut)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Game);
